import _ from 'lodash'

export function cleanDeferredOrders (settingsBlob) {
  cleanDeferredOrdersPrinter(settingsBlob.deferredOrders, settingsBlob)
}

export function cleanDeferredOrdersPrinter (deferredOrders, settingsBlob) {
  const printers = _.get(settingsBlob, 'printing.printers', []).map(it => it.id)
  if (deferredOrders.printer !== null && !printers.includes(deferredOrders.printer)) {
    deferredOrders.printer = null
  }
}
